<script setup lang="ts">
import { markRaw } from 'vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import FinancesCard from '@/components/performance-financiere/PerformanceFinanciereCard.vue'
import PerformanceFinanciereInfoCard from '@/components/performance-financiere/PerformanceFinanciereInfoCard.vue'
import PerformanceFinanciereRepartitionAgence from '@/components/performance-financiere/PerformanceFinanciereRepartitionAgence.vue'
import PerformanceFinanciereRepartitionFormation from '@/components/performance-financiere/PerformanceFinanciereRepartitionFormation.vue'
import PerformanceFinanciereRepartitionProduit from '@/components/performance-financiere/PerformanceFinanciereRepartitionProduit.vue'

const defaultComponents = [
  {
    id: 'performance-financiere-info',
    component: markRaw(PerformanceFinanciereInfoCard),
  },
  {
    id: 'repartition-par-agence',
    component: markRaw(PerformanceFinanciereRepartitionAgence),
  },
  {
    id: 'repartition-par-formation',
    component: markRaw(PerformanceFinanciereRepartitionFormation),
  },
  {
    id: 'repartition-par-produit',
    component: markRaw(PerformanceFinanciereRepartitionProduit),
  },
  {
    id: 'finances-card',
    component: markRaw(FinancesCard),
  },
]

const { components } = useComponentOrder('performances-financiere-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
